import PackageModel, { getPackagesFromMap, PackagesMap } from '@geartrack/shared-lib/dist/PackageModel'
import { IOrderResponse } from '../../../libraries/interfaces/tracker.interfaces'
import { useSettingsStore } from '../../../state/settings.store'

export const getLatestDateFromOrder = (orderResponse: IOrderResponse): string => {
  // assuming the states array is ordered desc by date already
  return orderResponse?.order?.states[0]?.date
}

export const sortedPackagesArray = (map: PackagesMap) => {
  const shouldSortByOrderField = useSettingsStore.getState().packagesSortByLatestStateDate

  if (shouldSortByOrderField) {
    return getPackagesFromMap(map, sortByOrder)
  }

  return getPackagesFromMap(map, sortByCreationDate)
}

export const sortByOrder = (a: PackageModel, b: PackageModel) => {
  if (a.collapsed && !b.collapsed) {
    return 1
  }

  if (!a.collapsed && b.collapsed) {
    return -1
  }

  // Fallback to ordering by creation date
  if (!a.order && !b.order) {
    return b.createdAt.getTime() - a.createdAt.getTime()
  }

  if (a.order && !b.order) {
    return -1
  }

  if (!a.order && b.order) {
    return 1
  }

  return b.order - a.order
}

export const sortByCreationDate = (a: PackageModel, b: PackageModel) => {
  if (a.collapsed && !b.collapsed) {
    return 1
  }

  if (!a.collapsed && b.collapsed) {
    return -1
  }

  return b.createdAt.getTime() - a.createdAt.getTime()
}
